export default __webpack_public_path__ + "static/media/walletConnect.304e3277.svg";